import React, { useEffect, useRef, useState } from 'react'
import BreadCrum from '../../../../lib/BreadCrum'
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, Divider, FormControlLabel, FormGroup, Grid, Hidden, Skeleton, Theme, Typography, useTheme } from '@mui/material'
import { BluePlusIcon, CheckIcon, EmailIcon, FailureIcon, Phoneicon, UnCheckIcon } from '../../../../assets/SvgIcons'
import { applicantStatusMasters, ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD, MAX_SCHEMES_SELECTED, MPOWER_ACCOUNT_TYPE_MASTER, USER_ROLES } from '../../../../utils/constant'
import { CustomeButton } from '../../../../lib/formik/NewFormInputs'
import ConfirmRecomment from '../../common/ConfirmRecomment'
import RiskProfilePopup from '../../common/RiskProfilePopup'
import AddtoCardPopup from '../../common/AddtoCardPopup'
import SuccessModal from '../../common/SuccessModal'
import FiveSchemeErrorMessage from '../common/FiveSchemeErrorMessage'
import ValidateDialogBox from '../common/ValidateDialogBox'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { MpowerValidationType, SwitchNavigationProps } from '../../types'
import { RootStateType } from '../../../../redux-store/reducers'
import { getMandateCreationDetails, setCheckedHoldingSchemes, setSelectedAllHoldingsInfo, setSelectedHoldingsIds, setSelectedHoldingsInfo, setSelectedSchemesObj } from '../../../../redux-store/actions/investorProfile'
import { EnuinStatusObj, GETINVESTMENTDETAILTYPE, GetInvestmentUserDetails, GetNotificationsResponseBody, getTransactionStatusCheckRes, TransactionStatusObj } from '../../../../redux-store/types/api-types'
import { MandateCreation } from '../../../../redux-store/types/investorProfile'
import { Formik, FormikProps, FormikValues, useFormik } from 'formik'
import { compare, getModeOfHoldingDisplay, isModuleAllowed, isOnboardingTypeMinor, maskInfo, toINR } from '../../../../utils/utilityFunctions'
import * as Yup from 'yup';
import { euinCheck, getInvestmentDetails, getInvestmentUserDetails, getRiskProfileCheck, getTransactionStatus, getTransactionStatusCheck, submitInvestmentDetails, submitRecomment } from '../../../../redux-store/actions/funds'
import { InitialData } from '../../../../redux-store/actions/investmentDetails'
import dayjs from 'dayjs'
import { addToCart, getCartItemsCount, setCartItemsCount } from '../../../../redux-store/actions/cart'
import { cancelPlaceOrderOnSkip, registerPlaceOrderOnSkip } from '../../../../redux-store/nomineeRetryRegistry'
import { AddToCartResponseBody, GetCartItemsCountResponseBody } from '../../../../redux-store/types/cart'
import Card from './Card'
import TransactionsDocumentUpload from '../../../../lib/TransactionsDocumentUpload'
import HoldingModal from '../common/HoldingModal'
import MoreFundsModal from '../../common/MoreFundsModal'
import HoldingFundMore from '../../common/HoldingFundMore'
import { HoldingsTableData } from '../holdings/types'
import TransactionStatusPopup from '../../common/TransactionStatusPopup'
import EUINPopup from '../../common/EUINPopup'
import { TransactionsDisclaimer, TransactionsDisclaimerText } from '../../../ApplicationDetails/TermsAndConditions'
import TransactionStatusCheckPopup from '../../common/TransactionStatusCheckPopup'
import { getNotifications } from '../../../../redux-store/actions/notifications'
import { storeNotifications } from '../../../../redux-store/actions/navbarInfo'
import { bseStarStatusColorMap } from '../../transcation/index'

function Redeem(): JSX.Element {
    const {
        palette,
        typography
    } = useTheme()
    const dispatch = useDispatch()
    const history = useHistory()

    const {
        selectedPortfiolio: {
            selectedPortfolio,
            selectedPortfolioObj
        },
        auth: { role = "", permissions = [] },
        id: {
            iwappRmId,
            clientInterfaceCode,
            investorClientId = ""
        },
        investorProfile: {
            selectedSchemesObj = {},
            selectAllHoldingsInfo
        }
    } = useSelector((store: RootStateType) => store);
    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData);
    const {
        locale,
        currencyCode,
        currencySymbol
    } = useSelector((store: RootStateType) => store.currencyInfo);

    const formikRef = useRef<FormikProps<FormikValues>>(null);

    const {
        pathname,
        state
    } = history.location

    const {
        selectedSchemes = [],
        clientCode = "",
        schemeDetails = [],
        folio = []
    } = (state as {
        selectedSchemes?: string[];
        clientCode: string;
        schemeDetails: Array<{
            scheme_id: string;
            isReinvestment: string;
        }>;
        folio?: {
            folioId?: string;
            schemeId?: string;
            marketValue: number;
            investedValue: number;
            id: string
        }[]
    }) ?? []

    const navState = state as SwitchNavigationProps

    //state
    const [details, setDetails] = useState<GETINVESTMENTDETAILTYPE>({} as GETINVESTMENTDETAILTYPE)
    const [isLoading, setIsLoading] = useState(true)
    const [confirmRecomment, setConfirmRecomment] = useState(false)
    const [successModal, setSuccessModal] = useState(false)
    const [userLoading, setUserLoading] = useState(false);
    const [userDetails, setUserDetails] = useState<GetInvestmentUserDetails>({} as GetInvestmentUserDetails);
    const [bankDetails, setBankDetails] = useState<Array<MandateCreation>>([] as Array<MandateCreation>);
    const [orderType, setOrderType] = useState<'order' | 'recomment' | 'investor'>('order');
    const [apiLoading, setApiLoading] = useState<'order' | 'recomment' | 'investor' | "">("");
    const [cartPopup, setCartPopup] = useState<boolean>(false);
    const [submit, setSubmit] = useState<FormikValues>({});
    const [isFiveSchemesDialogVisible, setFiveSchemesDialogVisible] = useState<boolean>(false)
    const [isValidationDialogVisible, setValidationDialogVisible] = useState<boolean>(false)
    const [validationErrorsArray, setValidationErrorsArray] = useState<{ schemeName: string; errorMessage: string }[]>([])
    const [riskProfilePopup, setRiskProfilePopup] = useState<boolean>(false);
    const [riskPopupText, setRiskPopupText] = useState<string>('');
    const [riskPflChkLoading, setRiskPflChkLoading] = useState<boolean>(false);
    const [isDocumentUploadDialogVisible, setDocumentUploadDialogVisible] = useState<boolean>(false);
    const [isDocumentUploadErrorDialogVisible, setDocumentUploadErrorDialogVisible] = useState<boolean>(false);
    const [recommendPlaceOrderResponse, setRecommendPlaceOrderResponse] = useState<any>({})
    const [isAddMoreHoldingDialogOpen, setAddMoreHoldingDialogOpen] = useState<boolean>(false)
    const [isSameSchemesDialogOpen, setSameSchemesDialogOpen] = useState<boolean>(false);
    const [EUINPopupVisible, setEUINPopupVisible] = useState<boolean>(false);
    const [EUINPopupRes, setEUINPopupRes] = useState<EnuinStatusObj>({} as EnuinStatusObj);
    const [EUINPopupLoading, setEUINPopupLoading] = useState<boolean>(false);
    const [disclaimerChecked, setDisclaimerChecked] = useState<boolean>(false);
    const [isTxnDialog, setIsTxnDialog] = useState<boolean>(false);

    const mfTxnStatus = userDetails?.application?.bseClientActivationStatus?.toLowerCase() !== 'active'

    //AddMore fund Model
    const [holdingsData, setHoldingsData] = useState<HoldingsTableData[]>([])

    const [transactionStatusPopup, setTransactionStatusPopup] = useState<boolean>(false);
    const [transactionStatusCheckPopup, setTransactionStatusCheckPopup] = useState<boolean>(false);
    const [TransactionStatusChkLoading, setTransactionStatusChkLoading] = useState<boolean>(false);
    const [transactionStatusPopupRes, setTransactionStatusPopupRes] = useState<TransactionStatusObj>({} as TransactionStatusObj);


    const RedeemSchema = Yup.object().shape({
        fund: Yup.lazy((_value) => {
            const getApiValidation = (index: number): MpowerValidationType => {
                return _value?.[index]?.investmentDetails?.validations?.find((item: MpowerValidationType) => item?.transactionType === 'RED')
            }

            return Yup.array().of(
                Yup.object().shape({
                    redeemValue: Yup
                        .string()
                        .required('Redeem is Required'),
                    installment: Yup
                        .mixed()
                        .test('installment-validation', function (value, context) {
                            const { parent, createError, path } = context;
                            const index = Number(path.match(/[\d,]+/g)?.[0])

                            if (parent?.redeemValue === 'amount') {
                                const minimumInstallmentAmount = getApiValidation(index)?.minimumInstallmentAmount

                                if (!`${value ?? ""}`.length) {
                                    return createError({ path, message: 'Amount is required' })
                                }
                                if (Number.isNaN(Number(value))) {
                                    return createError({ path, message: 'Invalid number' })
                                }
                                if (Number(value) < Number(minimumInstallmentAmount ?? "")) {
                                    return createError({
                                        path, message: `Minimum amount should be ${String.fromCharCode(parseInt(currencySymbol, 16))} ${Number(minimumInstallmentAmount ?? 0)}`
                                    })
                                }

                                return true
                            } else {
                                if (!`${value ?? ""}`.length) {
                                    return createError({ path, message: 'Units is required' })
                                }
                                if (Number.isNaN(Number(value))) {
                                    return createError({ path, message: 'Invalid number' })
                                }
                                const decimalPart = `${value ?? ""}`.split('.')[1]
                                if (decimalPart && decimalPart.length > 3) {
                                    return createError({ path, message: 'Maximum 3 digits are allowed after decimal point' })
                                }

                                if (Number(value) > Number(parent?.selectedSchemeDetails?.availableUnits ?? "")) {
                                    return createError({ path, message: `Maximum ${parent?.selectedSchemeDetails?.availableUnits ?? ""} units are available` })
                                }

                                return true
                            }
                        }),
                    bankType: Yup.string().required('Account is Required'),
                    entireBalance: Yup.boolean().notRequired(),
                }))
        }),
        ...((
            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
            ![USER_ROLES.INVESTOR].includes(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        ) ? {
            documents: Yup.array().of(
                Yup.object().shape({
                    documentId: Yup.string(),
                    documentType: Yup.string()
                })
            )
        } : {}),
    })

    const initialRouter = pathname?.split('/').filter((item) => item !== '')

    const rmRouterPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
        {
            name: 'Dashboard',
            path: '/dashboard',
            warning: true,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: initialRouter[1] + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            },
            warning: true,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: 'Mutual Fund',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode
            },
            search: "?tab=Holdings"
        },
        {
            name: 'Redeem',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}`,
        },
    ] : [])

    const investorRouterPath = [
        {
            name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: '/investor-dashboard',
            warning: true,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: 'Mutual Fund',
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            },
            search: "?tab=Holdings"
        },

        {
            name: 'Redeem',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
            state: {
                clientCode
            }
        },
    ]

    useEffect(() => {
        fetchAll()
    }, [clientCode])

    const fetchAll = async () => {
        if (!(selectedSchemes ?? []).length) {
            setIsLoading(false)

            formikRef.current?.resetForm({
                values: {
                    ...(formikRef.current?.values ?? {}),
                    fund: [],
                }
            })

            return
        }

        setIsLoading(true);

        const payload = {
            schemeIds: selectedSchemes?.map((item: any) => item?.scheme ?? ""),
            portfolioId: selectedPortfolio?.value,
            clientCode: clientCode,
            rmId: `${investorRmId}`,
            schemeDetails: selectedSchemes?.map((obj: any) => ({
                scheme_id: obj?.scheme ?? "",
                isReinvestment: obj?.isReinvestment ? obj?.isReinvestment : obj?.divReinvestAllowed ?? "",
            }))
        }

        const investmentDetailsRes = (await dispatch(getInvestmentDetails(payload))) as unknown | GETINVESTMENTDETAILTYPE;

        const bankDetailsRes = (await dispatch(getMandateCreationDetails({
            clientCode,
            portfolioId: selectedPortfolio?.value
        }))) as unknown as any

        const defaultAccount = bankDetailsRes?.find((account: MandateCreation) => account?.defaultAccount);

        setBankDetails(bankDetailsRes);
        setDetails(investmentDetailsRes as GETINVESTMENTDETAILTYPE);

        formikRef.current?.resetForm({
            values: {
                fund: [...((investmentDetailsRes as GETINVESTMENTDETAILTYPE)?.investmentDetails || [])]?.map((item, i) => ({
                    redeemValue: 'amount',
                    installment: '',
                    bankType: defaultAccount?.bankAccountNumber ?? '',
                    entireBalance: false,
                    selectedSchemeDetails: selectedSchemes[i],
                    investmentDetails: item,
                    folio: folio[i]
                })),
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                    ![USER_ROLES.INVESTOR].includes(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: formikRef.current?.values?.documents ?? []
                } : {})
            }
        })

        // setEntireBalance(false)
        // TotalValue()
        setIsLoading(false)
    }

    useEffect(() => {
        getUserApi();
        initialRender()
    }, [])

    // Discard any registered nominee-retry on unmount.
    useEffect(() => {
        return () => cancelPlaceOrderOnSkip();
    }, []);


    const initialRender = () => {
        dispatch(InitialData())
        dispatch(setSelectedHoldingsIds(selectedSchemes.map((item: any) => item?.scheme ? item?.scheme : item)))
    }

    const getUserApi = async () => {
        setUserLoading(true);
        if (clientCode) {
            const res1 = (await dispatch(getInvestmentUserDetails({ clientCode, portfolioId: selectedPortfolio?.value }))) as unknown | GetInvestmentUserDetails;
            setUserDetails(res1 as GetInvestmentUserDetails);
        }
        setUserLoading(false);
    };

    const handleRiskProfilePopup = (btnText: string) => {
        setRiskProfilePopup(false);

        if (btnText === 'continue') {
            if (orderType === 'order') {
                // For order flow, show confirmation popup directly
                handleConfirmRecommentOpen()
            }
        }
    }

    const handleDelete = (checkId: string, selectedUniqueId: string) => {

        setDetails((pre: GETINVESTMENTDETAILTYPE) => {

            const result = pre?.investmentDetails?.filter((item) => item?.schemeId !== checkId);

            // const modifiedSelectedSchemes = selectedSchemes?.filter((item: any) => item.id !== checkId);
            const modifiedSelectedSchemes = selectedSchemes?.filter((item: any) => item.uniqueId !== selectedUniqueId);

            history.replace({
                state: ({
                    selectedSchemes: modifiedSelectedSchemes,
                    clientCode,
                    schemeDetails: (modifiedSelectedSchemes ?? [])
                        .map((item: any) => ({
                            scheme_id: item?.schemeId ?? "-",
                            isReinvestment: item?.isReinvest ?? "-"
                        })),
                    folio: (modifiedSelectedSchemes ?? [])
                        .map((item: any) => ({
                            folioId: item.folioId,
                            id: item.id,
                            investedValue: item.investedValue,
                            marketValue: item.marketValue,
                            schemeId: item.scheme,
                        })),
                })
            })

            return { ...pre, result };
        })
    }

    const TotalValue = () => {

        const values = formikRef.current?.values?.fund ?? [];

        return values?.reduce((acc: FormikValues, curr: FormikValues) => {
            if (curr?.redeemValue === 'units') {
                return {
                    ...acc,
                    units: {
                        units: acc?.units?.units + (
                            (curr?.installment || curr?.redeemValue !== "") ?
                                Number(curr?.installment ?? "")
                                : 0
                        ),
                        remaining: acc?.units?.remaining + (
                            (curr?.installment || curr?.redeemValue !== "") ? (
                                Number(curr?.selectedSchemeDetails?.availableUnits ?? "") - Number(curr?.installment ?? "")
                            ) : 0
                        ),
                        value: acc?.units?.value + (
                            (curr?.installment || curr?.redeemValue !== "") ? (
                                Number(curr?.installment ?? "") * Number(curr?.selectedSchemeDetails?.navValue ?? "")
                            ) : 0
                        )
                    }
                }
            } else {
                return {
                    ...acc,
                    amount: {
                        units: acc?.amount?.units + (
                            (curr?.installment || curr?.redeemValue !== "") ? (
                                (Number(curr?.installment ?? "") / Number(curr?.selectedSchemeDetails?.navValue ?? ""))
                            ) : 0
                        ),
                        remaining: acc?.amount?.remaining + (
                            (curr?.installment || curr?.redeemValue !== "") ? (
                                (Number(curr?.selectedSchemeDetails?.availableUnits ?? "") * Number(curr?.selectedSchemeDetails?.navValue ?? "")) - Number(curr?.installment ?? "")
                            ) : 0
                        ),
                        value: acc?.amount?.value + (
                            (curr?.installment || curr?.redeemValue !== "") ?
                                Number(curr?.installment ?? "") : 0
                        )
                    }
                }
            }
        }, {
            amount: {
                units: 0,
                remaining: 0,
                value: 0
            },
            units: {
                units: 0,
                remaining: 0,
                value: 0
            }
        })
    }

    const handleConfirmRecommend = async (values: FormikValues) => {
        try {
            setApiLoading("recomment")

            const payload = (values?.fund ?? []).map((obj: FormikValues) => ({
                clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                amcId: obj?.investmentDetails?.fundAmcId ?? "",
                schemeId: obj?.investmentDetails?.schemeId ?? "",
                buySellType: "REDEMPTION",
                schemeName: obj?.investmentDetails?.fundName ?? "",
                categoryName: obj?.investmentDetails?.fundType ?? "",
                subCategoryName: obj?.investmentDetails?.fundCap ?? "",
                riskType: obj?.investmentDetails?.riskType ?? "",
                navDate: obj?.selectedSchemeDetails?.navDate ?? "",
                // navValue: obj?.selectedSchemeDetails?.navValue ?? "",
                navValue: details?.investmentDetails
                    ?.filter((item: any) => item?.schemeId === obj?.investmentDetails?.schemeId)?.[0]?.detailsList?.[1]?.value,
                folioNo: obj?.selectedSchemeDetails?.folioNo ?? "",
                recommendedAmount: obj.redeemValue === "amount" ? `${obj.installment}` : '',
                recommendedDate: dayjs().format("DD/MM/YYYY"),
                imgUrl: '',
                bankName: bankDetails.filter(item => item.bankAccountNumber === obj.bankType)[0].bankName,
                email: userDetails.email,
                mobileNo: userDetails.mobile,
                transMode: obj.redeemValue === "amount" ? "A" : 'U',
                recommendedUnits: obj.redeemValue === "amount" ? "" : `${obj.installment}`,
                bankAccountNumber: obj.bankType,
                portfolioId: selectedPortfolio.value,
                investedValue: `${obj?.selectedSchemeDetails?.investedValue ?? ""}`,
                marketValue: `${obj?.selectedSchemeDetails?.marketValue ?? ""}`,
                allUnitsFlag: obj.entireBalance ? "Y" : "N",
                rmId: `${investorRmId}`
            }))

            const res = (await dispatch(submitRecomment(payload))) as unknown as {
                isSuccess: boolean,
                message: string,
                response: Array<any>
            };

            if (res.isSuccess) {
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
            } else if (!res.isSuccess) {
                setConfirmRecomment(false)
                if (res.message) {
                    setFiveSchemesDialogVisible(true)
                } else {
                    setValidationErrorsArray(
                        res.response
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data.schemeName,
                                errorMessage: data.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }

        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setApiLoading("");
        }
    }
    const handleConformOrder = async (values: FormikValues) => {
        const payload = (values?.fund ?? []).map((obj: FormikValues) => {
            const navValue = details?.investmentDetails
                ?.filter((item: any) => item?.schemeId === obj?.investmentDetails?.schemeId)?.[0]?.detailsList?.[1]?.value;
            const calculatedAmount = obj.redeemValue === "amount" ?
                Number(obj?.installment ?? "") :
                (Number(obj?.installment ?? "") * Number(navValue ?? ""))

            const calculatedUnits = (obj.redeemValue === "units" ?
                Number(obj?.installment ?? "") :
                ((Number(obj?.installment ?? "") / Number(navValue ?? "")))).toFixed(4);


            return {
                clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                portfolioId: selectedPortfolio?.value,
                portfolioName: selectedPortfolio?.label,
                fromScheme: obj?.selectedSchemeDetails?.scheme ?? "",
                trType: "REDEMPTION",
                redemptionType: obj?.entireBalance ? "F" : "P", //string("F"/"P")
                redemptionMode: obj?.redeemValue === "amount" ? "A" : "U", //string("U"/"A")
                amount: calculatedAmount,
                units: calculatedUnits,
                folio: obj?.selectedSchemeDetails?.folioNo ?? "",
                mobile: userDetails.mobile,
                email: userDetails.email,
                schemeName: obj?.selectedSchemeDetails?.schemeName ?? "",
                bankAccountNumber: obj?.bankType ?? "",
                // cartId:number,
                isRecommended: true,
                isDiy: false,
                rmId: `${investorRmId}`,
                amcId: obj?.investmentDetails?.fundAmcId ?? "",
                "cartId": null,
            }
        })

        try {
            setApiLoading("order")

            const res = (await dispatch(submitInvestmentDetails({
                // ...(ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD ? {
                accountType: selectedPortfolioObj?.portfolioAccountType,
                // } : {}),
                orderDetails: payload,
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                    ![USER_ROLES.INVESTOR].includes(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: values?.documents?.filter((obj: {
                        documentId: string;
                        documentType: string;
                    }) => obj.documentId !== "" && obj.documentType !== "")
                } : {})
            }))) as unknown as {
                isSuccess: boolean,
                message: string,
                ordersValidation: Array<any>
            };

            if (res.isSuccess) {
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
                // const notificationsPayload = {
                //     rmId: [USER_ROLES.RM].includes(role) ? [`${iwappRmId}`] : [],
                //     category: [],
                //     clientCode: [USER_ROLES.INVESTOR].includes(role) ? [clientInterfaceCode] : [],
                //     limit: 3,
                //     page: 1,
                //     sort: 'notificationTimestamp',
                //     order: 'DESC'
                // }
                // const getNotificationsData = (await dispatch(getNotifications(notificationsPayload))) as unknown as GetNotificationsResponseBody;
                // dispatch(storeNotifications(getNotificationsData.data ?? []));
            } else if (!res.isSuccess) {
                setConfirmRecomment(false)
                if (res.message) {
                    setFiveSchemesDialogVisible(true)
                } else {
                    setValidationErrorsArray(
                        res.ordersValidation
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data.schemeName,
                                errorMessage: data.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setConfirmRecomment(false);
            setRiskProfilePopup(false);
            setApiLoading("")
        }
    };

    const handleSuccess = () => {
        history.push('/cart', { clientCode })
    }

    const hasDuplicateSchemes = (arr: any) => {
        const codeSet = new Set();

        for (const item of arr) {
            const key = `${item.isinCode}-${item.folioNo}`;
            if (codeSet.has(key)) {
                return true;
            }
            codeSet.add(key);
        }

        return false;
    }

    const handleSameSchemeDialogClose = () => {
        setSameSchemesDialogOpen(false)
    }

    const handleSameSchemeDialogConfirm = async () => {

        handleSameSchemeDialogClose()

        if (!formikRef.current) {
            return
        }

        const { values } = formikRef.current

        if (orderType === 'investor') {
            try {
                setApiLoading("investor");

                const payload = (values?.fund ?? []).map((obj: FormikValues) => {
                    return ({
                        aumAmount: "",
                        isDividendReinvestment: obj?.investmentDetails?.divReinvestAllowed ?? "",
                        mPowerScheme: obj?.investmentDetails?.mPowerScheme ?? "",
                        trType: "REDEMPTION", //M
                        categoryName: obj?.selectedSchemeDetails?.categoryName ?? "", //M
                        clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode, //M
                        exitLoad: "",
                        navValue: `${details?.investmentDetails
                            ?.filter((item: any) => item?.schemeId === obj?.investmentDetails?.schemeId)?.[0]?.detailsList?.[1]?.value ?? ""}`, //M
                        amount: obj.redeemValue === "amount" ? obj.installment : '', // if transmode- A , AMOUNT SHOULD HAVE A VALUE
                        units: `${obj.redeemValue === "units" ? obj.installment : ''}`, // if transmode- U , UNITS SHOULD HAVE A value ,
                        balanceUnits: `${obj?.selectedSchemeDetails?.units ?? ""}`, //M
                        schemeId: obj?.investmentDetails?.schemeId ?? "", //M
                        schemeName: obj?.selectedSchemeDetails?.schemeName ?? "", //M
                        subCategoryName: obj?.selectedSchemeDetails?.subCategoryName ?? "", //M
                        y3Returns: "",
                        mandateId: "",
                        navDate: obj?.selectedSchemeDetails?.navDate ?? "", //M
                        folioNo: obj?.selectedSchemeDetails?.folioNo ?? "",
                        investedValue: `${obj?.selectedSchemeDetails?.investedValue ?? ""}`, //M
                        marketValue: `${obj?.selectedSchemeDetails?.marketValue ?? ""}`, //M
                        transMode: obj.redeemValue === "amount" ? "A" : "U", //M
                        portfolioId: selectedPortfolio.value, //M,
                        bankName: bankDetails?.filter(item => item?.bankAccountNumber === obj.bankType)?.[0]?.bankName, //M
                        bankAccountNumber: obj.bankType, //M
                        rmId: `${investorRmId}`,
                        amcId: obj?.selectedSchemeDetails?.amcId ?? "",
                        allUnitsFlag: obj.entireBalance ? "Y" : "N"
                    })
                })

                const res = ((await dispatch(addToCart(payload as any))) as unknown) as AddToCartResponseBody;
                if (res.isSuccess) {
                    setConfirmRecomment(false)
                    const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                        portfolioId: selectedPortfolio?.value
                    })) as unknown as Promise<GetCartItemsCountResponseBody>)

                    if (isSuccess) {
                        dispatch(setCartItemsCount(cartItemsCount));
                        dispatch(setSelectedHoldingsInfo([]))
                        dispatch(setSelectedAllHoldingsInfo([]))
                    }

                    setCartPopup(true)
                } else if (!res.isSuccess) {
                    setConfirmRecomment(false)
                    if (res.message) {
                        setFiveSchemesDialogVisible(true)
                    } else {
                        setValidationErrorsArray(
                            res.response
                                .filter(data => !data.isSuccess)
                                .map(data => ({
                                    schemeName: data.schemeName,
                                    errorMessage: data.message
                                }))
                        )
                        setValidationDialogVisible(true)
                    }
                }
            } catch (err) {
                console.log(err)
            } finally {
                setApiLoading("");
            }
        } else {
            if (orderType === 'order') {

                handleTransactionStatusCheck1();
            } else {
                handleConfirmRecommentOpen();
            }
        }
    }

    const handleTransactionStatusCheck = async () => {
        try {
            setTransactionStatusChkLoading(true);
            const transactionStatusCheckRes = (await dispatch(getTransactionStatus({
                clientCode: clientInterfaceCode ?? '',
            }))) as unknown as TransactionStatusObj
            if (!transactionStatusCheckRes?.kycActive) {
                setTransactionStatusPopup(true)
                setTransactionStatusPopupRes(transactionStatusCheckRes)
            } else {
                handleConfirmRecommentOpen();
            }

        } catch (e) {
            console.log("Error: ", e)
        } finally {
            setTransactionStatusChkLoading(false)
        }
    }

    const [transactionStatusCheckPopupRes, setTransactionStatusCheckPopupRes] = useState<getTransactionStatusCheckRes>({} as getTransactionStatusCheckRes);

    const handleTransactionStatusCheck1 = async () => {
        try {
            setTransactionStatusChkLoading(true);
            registerPlaceOrderOnSkip(() => handleConformOrder(formikRef.current?.values ?? {}));
            const transactionStatusCheckRes = (await dispatch(getTransactionStatusCheck({
                rmId: `${iwappRmId ?? ''}`,
                clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                // transactionType: 'sip'
            }))) as unknown as getTransactionStatusCheckRes;
            if (!transactionStatusCheckRes) return;
            cancelPlaceOrderOnSkip();
            const showPopup = transactionStatusCheckRes.isMessage;
            if (showPopup) {
                setTransactionStatusCheckPopup(true);
                setTransactionStatusCheckPopupRes(transactionStatusCheckRes);
            } else {
                // Transaction status check passed, now do risk profile check
                handleRiskProfileCheckForOrder();
            }
        } catch (e) {
            cancelPlaceOrderOnSkip();
            console.log("Error: ", e)
        } finally {
            setTransactionStatusChkLoading(false)
        }
    }

    const handleRiskProfileCheckForOrder = async () => {
        try {
            setRiskPflChkLoading(true)
            const riskProfileCheckRes = (await dispatch(getRiskProfileCheck({
                clientCode: clientInterfaceCode ? clientInterfaceCode : navState.clientCode,
                // schemeCode: [navState.itemData.schemeId]
                schemeCode: (formikRef?.current?.values?.fund ?? []).map((obj: FormikValues) => obj?.selectedSchemeDetails?.schemeId)
            }))) as unknown as {
                isSuccess: boolean,
                displayText: string
            }

            if (!riskProfileCheckRes?.isSuccess) {
                setRiskProfilePopup(true)
                setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
            } else {
                handleConfirmRecommentOpen();
            }
        } catch (e) {
            console.log(e)
        } finally {
            setRiskPflChkLoading(false)
        }

    }
    const handleTransactionStatusPopup = (btnText: string) => {
        setTransactionStatusPopup(false);
        if (compare(btnText, ['continue'])) {
            handleConfirmRecommentOpen();
        }
    }

    const handleTransactionStatusCheckPopup = (btnText: string) => {
        setTransactionStatusCheckPopup(false);
        if (compare(btnText, ['continue'])) {
            if (orderType === 'order') {
                // For order flow, proceed to risk profile check
                handleRiskProfileCheckForOrder();
            }
        }
    }

    const onSubmit = async (values: FormikValues) => {
        // setSubmit(values);

        if ((
            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
            ![USER_ROLES.INVESTOR].includes(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        )) {
            if (values?.documents?.length === 1 && (values?.documents[0]?.documentId === '' || values?.documents[0]?.documentType === '')) {
                setDocumentUploadErrorDialogVisible(true)
                return
            }
        }

        // Checking if multiple orders with the same scheme/folio combination are there ot not

        const hasDuplicates = hasDuplicateSchemes(
            (values?.fund ?? [])?.map((obj: any) => ({ ...(obj?.selectedSchemeDetails ?? {}) }))
        )

        if (hasDuplicates) {
            setSameSchemesDialogOpen(true)
            return
        } else {
            handleSameSchemeDialogConfirm()
        }
    }

    const handleSuccessPopup = () => {
        // history.goBack()
        if (role === USER_ROLES.INVESTOR) {
            history.push('/investor-dashboard')
        } else {
            history.push('/dashboard')
        }
    }

    const handleCloseFiveSchemesDialog = () => {
        setFiveSchemesDialogVisible(false)
    }

    const handleValidationDialogClose = () => {
        setValidationDialogVisible(false)
    }

    const selectedBankDetails = (bankValue: string) => {
        const result = [...bankDetails].filter((item) => item.bankAccountNumber === bankValue)
        return result.length > 0 ? `${result?.[0]?.bankName}-${result?.[0]?.bankAccountNumber}` : "-"
    }

    const handleDocumentUploadDialogOpen = () => {
        setDocumentUploadDialogVisible(true)
    }

    const handleDocumentUploadDialogClose = () => {
        setDocumentUploadDialogVisible(false)
    }

    const handleDocumentUploadErrorDialogClose = () => {
        setDocumentUploadErrorDialogVisible(false)
    }

    const addFunds = async (schemes: any, addedFolio?: any) => {
        // schemes currently in formik
        const currentSchemesArr = (formikRef.current?.values?.fund ?? []).map((obj: any) => obj.selectedSchemeDetails)

        // latest added schemes excluding the schemes in formik
        const latestAddedSchemes = schemes?.filter((obj: any) => !currentSchemesArr.find((currObj: any) => currObj.uniqueId === obj.uniqueId))

        if (!(latestAddedSchemes ?? []).length) {
            return
        }

        try {
            setIsLoading(true);
            const payload = {
                // passing only those schemeIds which have been added via Add more funds, NOT passing those schemes already in Formik
                // schemeIds: Object.values(schemes)?.map((item: any) => item?.scheme ? item?.scheme : item),
                schemeIds: (latestAddedSchemes ?? [])?.map((item: any) => item?.scheme ?? ""),
                portfolioId: selectedPortfolio?.value,
                clientCode: clientCode,
                rmId: `${investorRmId}`,
                // schemeDetails: Object.values(schemes)?.map((obj: any) => ({
                //     scheme_id: obj?.scheme ?? "",
                //     isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                // }))
                schemeDetails: (latestAddedSchemes ?? [])?.map((obj: any) => ({
                    scheme_id: obj?.scheme ?? "",
                    isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                }))
            }

            const res = (await dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown
            setDetails(res as GETINVESTMENTDETAILTYPE);

            // extracting ISIN codes from the response
            const responseIsinCodes = ((res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []).map((item: any) => item.isinCode) as Array<string>

            // Filtering out those schemes for which we did not get the api response based on the isin code
            const modifiedLatestAddedSchemes = latestAddedSchemes.filter((item: any) => responseIsinCodes.includes(item.isinCode));

            const defaultAccount = bankDetails?.find((account: MandateCreation) => account?.defaultAccount);

            const formInitial = [...(res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []].map((item, i) => {
                const addedFolio = {
                    folioId: modifiedLatestAddedSchemes[i].folioId,
                    id: modifiedLatestAddedSchemes[i].id,
                    investedValue: modifiedLatestAddedSchemes[i].investedValue,
                    marketValue: modifiedLatestAddedSchemes[i].marketValue,
                    schemeId: modifiedLatestAddedSchemes[i].scheme,
                }

                return {
                    redeemValue: 'amount',
                    installment: '',
                    bankType: defaultAccount?.bankAccountNumber ?? '',
                    entireBalance: false,
                    // selectedSchemeDetails: schemes[i],
                    selectedSchemeDetails: modifiedLatestAddedSchemes[i],
                    investmentDetails: item,
                    folio: addedFolio
                }
            })
            const currentForm = [...formikRef.current?.values?.fund]
            // const newFrom = [...formInitial]

            // const getId = (item: any) => item?.map((obj: any) => obj.folio.id)

            // const currentSchemeId = getId([...currentForm])
            // const newSchemeId = getId([...newFrom])

            // const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.folio.id))
            // const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.folio.id))

            const updatedFundsArray = [...currentForm, ...formInitial]

            history.replace({
                state: ({
                    selectedSchemes: updatedFundsArray
                        .map(obj => obj?.selectedSchemeDetails ?? {})
                        .map(item => ({
                            ...item,
                            folioId: item.folioNo,
                            scheme: item.schemeId,
                            id: item.id,
                            marketValue: item.marketValue,
                            investedValue: item.investedValue,
                            isReinvestment: item?.isReinvest
                        })),
                    clientCode,
                    schemeDetails: updatedFundsArray
                        .map(obj => obj?.selectedSchemeDetails ?? {})
                        .map(item => ({
                            scheme_id: item?.schemeId ?? "-",
                            isReinvestment: item?.isReinvest ?? "-"
                        })),
                    folio: updatedFundsArray
                        .map(obj => obj?.selectedSchemeDetails ?? {})
                        .map(item => ({
                            folioId: item.folioId,
                            id: item.id,
                            investedValue: item.investedValue,
                            marketValue: item.marketValue,
                            schemeId: item.scheme,
                        }))
                })
            })

            dispatch(setSelectedHoldingsInfo(
                updatedFundsArray.map(obj => ({
                    checkedId: obj?.selectedSchemeDetails?.id,
                    schemeId: obj?.selectedSchemeDetails?.scheme,
                    folioNo: obj?.selectedSchemeDetails?.folioNo ?? "",
                    uniqueId: obj?.selectedSchemeDetails?.uniqueId
                }))))

            dispatch(setSelectedAllHoldingsInfo(
                updatedFundsArray.map(obj => obj?.selectedSchemeDetails ?? {})
            ))

            formikRef.current?.resetForm({
                values: {
                    fund: updatedFundsArray,
                    ...((
                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                        ![USER_ROLES.INVESTOR].includes(role) &&
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        documents: formikRef.current?.values?.documents ?? []
                    } : {}),
                }
            })
        } catch (err) {
            console.log('error', err)
        } finally {
            setIsLoading(false)
        }
    };

    const handleConfirmRecommentOpen = async () => {
        setConfirmRecomment(true);
        // if (orderType !== 'order') {
        //     setConfirmRecomment(true);
        //     return;
        // }

    }

    const handleEuinCheckClose = () => {
        setEUINPopupVisible(false);
        EUINPopupRes?.isValid && setConfirmRecomment(true);
    }

    const handleProceed = () => {
        const data = selectAllHoldingsInfo.map(item => ({
            ...item,
            folioId: item.folioNo,
            scheme: item.schemeId,
            id: item.id,
            marketValue: item.marketValue,
            investedValue: item.investedValue,
            isReinvestment: item?.isReinvest
        }))

        const checkedIds = data.map((obj) => obj.scheme)

        const folioData = data.map((obj) => ({
            folioId: obj.folioId,
            schemeId: obj.scheme,
            id: obj.id,
            marketValue: obj.marketValue,
            investedValue: obj.investedValue
        }))

        const schemeDetails = selectAllHoldingsInfo?.map((obj) => ({
            scheme_id: obj?.schemeId ?? "-",
            isReinvestment: obj?.isReinvest ?? "-"
        }))

        dispatch(setSelectedHoldingsIds([...[]]))
        dispatch(setCheckedHoldingSchemes([...checkedIds]))

        // history.replace({
        //     state: ({
        //         selectedSchemes: [...data],
        //         clientCode,
        //         schemeDetails,
        //         folio: folioData
        //     })
        // })

        setAddMoreHoldingDialogOpen(false)

        addFunds([...data], folioData)
    }

    let successMessage = ""
    let subSuccessMessage = ""

    if (orderType === 'recomment') {
        successMessage = "Your Suggestion is sent successfully to the Investor."
    } else {
        if (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD && selectedPortfolioObj?.portfolioAccountType) {
            if (![USER_ROLES.INVESTOR].includes(role) &&
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["POA"]) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} sent to the checker for approval.`
            }
            if (![USER_ROLES.INVESTOR].includes(role) &&
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["EXY"]
            ) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} successfully sent to the investor for approval. Once authorized and approved the order will be placed.`
                subSuccessMessage = `${recommendPlaceOrderResponse?.message ?? ""}`;
            }
        } else {
            successMessage = "The transaction link will be sent via email by BSE Star for authorisation and completion of the transaction."
        }

    }

    const isMinor = isOnboardingTypeMinor(userDetails?.application?.onboardingType || '');
    const investorName = isMinor ? `${userDetails?.application?.applicants?.[0]?.minorFirstName} ${userDetails?.application?.applicants?.[0]?.minorLastName}` : userDetails?.name;


    return (
        <>
            <BreadCrum array={![USER_ROLES.INVESTOR].includes(role) ? rmRouterPath : investorRouterPath} />
            <Typography
                variant='h1'
                color={palette.text.primary}
                fontSize={{
                    sm: '16px',
                    xs: '16px',
                    md: '24px',
                    lg: '24px'
                }}
                mt={2}
            >
                Redeem
            </Typography>
            <Formik
                innerRef={formikRef}
                initialValues={{
                    fund: [{
                        redeemValue: 'amount',
                        installment: '',
                        bankType: '',
                        entireBalance: false,
                    }],
                    ...((
                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                        ![USER_ROLES.INVESTOR].includes(role) &&
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        documents: [{
                            documentId: "",
                            documentType: ""
                        }]
                    } : {})
                }}
                validationSchema={RedeemSchema}
                onSubmit={onSubmit}
            >
                {({ values, handleSubmit }) => {

                    const totalAmount = (values?.fund ?? []).reduce((acc: number, curr: FormikValues) => {
                        return (curr?.redeemValue === 'amount') ? acc + Number(curr?.installment ?? 0) : acc
                    }, 0)

                    const totalUnits = (values?.fund ?? []).reduce((acc: number, curr: FormikValues) => {
                        return (curr?.redeemValue === 'units') ? acc + Number(curr?.installment ?? 0) : acc
                    }, 0)
                    // TotalValue()

                    return (
                        <>
                            <Grid
                                container
                                marginTop={2}
                                spacing={2}
                            >
                                <Grid
                                    item
                                    lg={8}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    sx={{
                                        display: 'flex',
                                        rowGap: '25px',
                                        flexDirection: 'column'
                                    }}
                                >
                                    {(values?.fund ?? []).map((obj: FormikValues, index: number) => {
                                        return (
                                            <Card
                                                key={index}
                                                isSubmitting={!!apiLoading}
                                                isLoading={isLoading}
                                                data={obj?.investmentDetails}
                                                clientCode={clientCode}
                                                // itemData={itemData}
                                                itemData={{
                                                    units: obj?.selectedSchemeDetails?.units,
                                                    folioNo: obj?.selectedSchemeDetails?.folioNo,
                                                    navDate: obj?.investmentDetails?.detailsList[1].title,
                                                    navValue: obj?.investmentDetails?.detailsList[1].value,
                                                    balanceAmount: obj?.selectedSchemeDetails?.balanceAmount,
                                                    availableUnits: obj?.selectedSchemeDetails?.availableUnits
                                                }}
                                                bankList={bankDetails}
                                                navState={{ itemData: selectedSchemes[index] }}
                                                id={index}
                                                folio={obj.folio}
                                                handleDelete={handleDelete}
                                            />
                                        )
                                    })}
                                    {selectedSchemes.length < MAX_SCHEMES_SELECTED && (
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            {isLoading && (
                                                <Skeleton
                                                    variant="rectangular"
                                                    width={200}
                                                    height={30}
                                                />
                                            )}
                                            {!isLoading && (
                                                <Button
                                                    variant="text"
                                                    onClick={() => setAddMoreHoldingDialogOpen(true)}
                                                    sx={{
                                                        gap: '10px',
                                                        '&:hover': {
                                                            background: 'transparent',
                                                        },
                                                        '&:disabled': {
                                                            opacity: 0.5
                                                        }
                                                    }}
                                                    disabled={!!apiLoading || TransactionStatusChkLoading}
                                                >
                                                    <BluePlusIcon />
                                                    <Typography
                                                        variant="body_500"
                                                        color={palette.text.secondary}
                                                        sx={{
                                                            textDecoration: 'dashed',
                                                            textDecorationColor: palette.primary[500],
                                                            textDecorationThickness: '2px',
                                                        }}
                                                    >
                                                        Add More Holding
                                                    </Typography>
                                                </Button>
                                            )}
                                        </Box>
                                    )}
                                </Grid>
                                <Grid
                                    item
                                    lg={4}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                >
                                    {(
                                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                        ![USER_ROLES.INVESTOR].includes(role) &&
                                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                    ) && (
                                            <Box
                                                sx={{
                                                    background: palette.background.paper,
                                                    padding: '20px',
                                                    borderRadius: '20px',
                                                    marginBottom: "20px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    flexDirection: "column"
                                                }}
                                                boxShadow={1}
                                            >
                                                <Typography
                                                    variant="body_500"
                                                    sx={{
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: `${palette.text.secondary}B2`,
                                                    }}
                                                >
                                                    You can add minimum 1 attachment and maximum 5 attachments
                                                </Typography>
                                                <Typography
                                                    variant='body_400'
                                                    sx={{
                                                        color: palette.text.primary,
                                                        alignSelf: "flex-start",
                                                        marginTop: "10px"
                                                    }}
                                                >
                                                    Documents Uploaded: {
                                                        values?.documents?.filter((obj: {
                                                            documentId: string;
                                                            documentType: string;
                                                        }) => obj.documentId !== "" && obj.documentType !== "")?.length ?? "0"
                                                    }
                                                </Typography>
                                                <Button
                                                    sx={{
                                                        ...typography.body_500,
                                                        color: palette.primary[500],
                                                        padding: "5px",
                                                        fontWeight: 600,
                                                        marginTop: "15px"
                                                    }}
                                                    onClick={handleDocumentUploadDialogOpen}
                                                    disabled={isLoading || !!apiLoading}
                                                >
                                                    Upload Documents
                                                </Button>
                                            </Box>
                                        )}
                                    <Box
                                        sx={{
                                            background: palette.background.paper,
                                            padding: '25px 30px 30px',
                                            borderRadius: '20px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '35px'
                                        }}
                                        boxShadow={1}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                            {userLoading ? (
                                                <CircularProgress />
                                            ) : (
                                                <img
                                                    src={`https://ui-avatars.com/api/?name=${`${investorName}`}&background=${palette.primary[50]?.slice(1)}&color=${palette.primary[500]?.slice(1)}`}
                                                    style={{ borderRadius: '50%' }}
                                                    alt="Bank name" />
                                            )}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    rowGap: "5px",
                                                    flex: 1
                                                }}
                                            >
                                                {userLoading && (
                                                    <>
                                                        <Skeleton variant='text' animation="wave" />
                                                        <Skeleton variant='text' animation="wave" />
                                                    </>
                                                )}
                                                {!userLoading && (
                                                    <>
                                                        <Typography
                                                            variant='h2'
                                                            sx={(theme: Theme) => ({
                                                                lineHeight: "25px",
                                                                letterSpacing: "0.01px",
                                                                color: theme.palette.text.primary
                                                            })}
                                                        >
                                                            {maskInfo(investorName || '')}
                                                        </Typography>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "5px",
                                                                flexWrap: "wrap",
                                                            }}
                                                        >
                                                            <Typography
                                                                variant='body_500'
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {/* {userDetails?.applicationType ?? ""} */}
                                                                {
                                                                    isMinor
                                                                        ? "Minor"
                                                                        : userDetails?.status ?
                                                                            applicantStatusMasters[userDetails.status] ?
                                                                                applicantStatusMasters[userDetails.status] : userDetails.status
                                                                            : "N/A"
                                                                }
                                                            </Typography>
                                                            {/* <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant='body_500'
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {selectedPortfolio?.label ?? ""}
                                                            </Typography> */}
                                                            <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary
                                                                })}
                                                            >
                                                                {userDetails?.accountType ?? ""}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {getModeOfHoldingDisplay(userDetails?.modeOfHolding || "") ?? "-"}
                                                            </Typography>
                                                            {/* <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary
                                                                })}
                                                            >
                                                                {
                                                                    isMinor
                                                                        ? "Minor"
                                                                        : userDetails?.status ?
                                                                            applicantStatusMasters[userDetails.status] ?
                                                                                applicantStatusMasters[userDetails.status] : userDetails.status
                                                                            : "N/A"
                                                                }
                                                            </Typography> */}
                                                            <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {userDetails?.application?.clientInterfaceCode ?? ""}
                                                            </Typography>
                                                        </Box>
                                                    </>
                                                )}
                                            </Box>
                                        </Box>
                                        {![USER_ROLES.INVESTOR].includes(role) && (
                                            <Box width={'100%'}>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px',
                                                        width: '100%'
                                                    }}
                                                >
                                                    <EmailIcon />
                                                    {userLoading ? (
                                                        <Skeleton
                                                            variant='text'
                                                            animation="wave"
                                                            width='100%'
                                                        />
                                                    ) : (
                                                        <Typography
                                                            variant='body_500'
                                                            color={palette.text.primary}
                                                            fontSize={{
                                                                sm: '14px',
                                                                xs: '14px',
                                                                md: '16px',
                                                                lg: '16px'
                                                            }}
                                                        >
                                                            {maskInfo(userDetails.email || '')}
                                                        </Typography>
                                                    )}
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px',
                                                        width: '100%'
                                                    }}
                                                >
                                                    <Phoneicon />
                                                    {userLoading ? (
                                                        <Skeleton
                                                            variant='text'
                                                            animation="wave"
                                                            width='100%'
                                                        />
                                                    ) : (
                                                        <Typography
                                                            variant='body_500'
                                                            color={palette.text.primary}
                                                            fontSize={{
                                                                sm: '14px',
                                                                xs: '14px',
                                                                md: '16px',
                                                                lg: '16px'
                                                            }}
                                                        >
                                                            {maskInfo(userDetails.mobile || '')}
                                                        </Typography>
                                                    )}
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                    <Typography>MF Transaction Status:</Typography>
                                                    {userLoading ? (
                                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                                    ) :
                                                        (
                                                            <Typography
                                                                variant="body_500"
                                                                color={bseStarStatusColorMap[`${userDetails?.application?.bseClientActivationStatus ?? ""}`.toLowerCase()] ?? 'text.primary'}
                                                                sx={{
                                                                    letterSpacing: '0.02px',
                                                                    textTransform: "capitalize"
                                                                }}
                                                            >
                                                                {userDetails?.application?.bseClientActivationStatus ?? 'N/A'}
                                                            </Typography>
                                                        )}
                                                </Box>

                                                {USER_ROLES.INVESTOR !== role && (userLoading ? (
                                                    <Skeleton variant="text" animation="wave" width={'100%'} />
                                                ) : (
                                                    <Box sx={{ width: '100%', mt: 3 }}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}
                                                                control={
                                                                    <Checkbox
                                                                        size="medium"
                                                                        disableRipple
                                                                        checkedIcon={<CheckIcon />}
                                                                        icon={<UnCheckIcon />}
                                                                        sx={{
                                                                            padding: 0,
                                                                            '&:hover': {
                                                                                backgroundColor: 'transparent',
                                                                            },
                                                                        }}

                                                                        onChange={() => setIsTxnDialog(true)}
                                                                        checked={disclaimerChecked}
                                                                    />}
                                                                label={<TransactionsDisclaimer disclaimerChecked={disclaimerChecked} setDisclaimerChecked={setDisclaimerChecked} />}
                                                            />
                                                        </FormGroup>
                                                    </Box>
                                                ))}

                                            </Box>
                                        )}
                                        <Divider />
                                        {/* <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection:
                                                {
                                                    xs: 'column',
                                                    sm: 'column',
                                                    md: 'row',
                                                    lg: 'row'
                                                },
                                                justifyContent: 'space-between',
                                                gap: {
                                                    xs: '10px',
                                                    sm: '10px',
                                                    md: '0px',
                                                    lg: '0px'
                                                }
                                            }}> */}
                                        {/* <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '10px',
                                                    justifyContent: 'space-between'
                                                }}
                                            > */}
                                        {/* <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: {
                                                            lg: 'column',
                                                            md: 'column',
                                                            sm: 'row',
                                                            xs: 'row'
                                                        },
                                                        justifyContent: {
                                                            xs: 'space-between',
                                                            sm: 'space-between',
                                                            md: 'unset',
                                                            lg: 'unset'
                                                        },
                                                        gap: '8px'
                                                    }}
                                                >
                                                    <Typography
                                                        variant='body_500'
                                                        color={palette.text.secondary}
                                                        fontSize={{
                                                            sm: '14px',
                                                            xs: '14px',
                                                            md: '16px',
                                                            lg: '16px'
                                                        }}
                                                    >
                                                        Redeemable Units
                                                    </Typography>

                                                    {isLoading ? (
                                                        <Skeleton variant='text' animation="wave" />
                                                    ) :
                                                        (
                                                            <Typography
                                                                variant='body_600'
                                                                fontSize={{
                                                                    sm: '14px',
                                                                    xs: '14px',
                                                                    md: '16px',
                                                                    lg: '16px'
                                                                }}
                                                            >
                                                                {values?.redeemValue === 'amount' ? TotalValue()?.amount?.units : TotalValue()?.units?.units}
                                                                {(
                                                                    Number(TotalValue()?.amount?.units ?? "") + Number(TotalValue()?.units?.units ?? "")
                                                                ).toFixed(2)}
                                                            </Typography>
                                                        )
                                                    }
                                                </Box> */}
                                        {/* <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: {
                                                            lg: 'column',
                                                            md: 'column',
                                                            sm: 'row',
                                                            xs: 'row'
                                                        },
                                                        justifyContent: {
                                                            xs: 'space-between',
                                                            sm: 'space-between',
                                                            md: 'unset',
                                                            lg: 'unset'
                                                        },
                                                        gap: '8px'
                                                    }}
                                                >
                                                    <Typography
                                                        variant='body_500'
                                                        color={palette.text.secondary}
                                                        fontSize={{
                                                            sm: '14px',
                                                            xs: '14px',
                                                            md: '16px',
                                                            lg: '16px'
                                                        }}
                                                    >
                                                        Redeem Value
                                                    </Typography>
                                                    {isLoading ? (
                                                        <Skeleton
                                                            variant='text'
                                                            animation="wave"
                                                        />
                                                    ) : (
                                                        <Typography
                                                            variant='body_600'
                                                            fontSize={{
                                                                sm: '14px',
                                                                xs: '14px',
                                                                md: '16px',
                                                                lg: '16px'
                                                            }}
                                                        >
                                                            {String.fromCharCode(parseInt(currencySymbol, 16))}
                                                            {formik?.values?.redeemValue === 'amount' ? TotalValue()?.amount?.value : TotalValue()?.units?.value}
                                                            {(
                                                                Number(TotalValue()?.amount?.value ?? "") +
                                                                Number(TotalValue()?.units?.value ?? "")
                                                            ).toFixed(2)}
                                                        </Typography>
                                                    )
                                                    }
                                                </Box> */}
                                        {/* </Box> */}
                                        {/* <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '10px',
                                                    justifyContent: 'space-between'
                                                }}
                                            > */}
                                        {/* <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: {
                                                            lg: 'column',
                                                            md: 'column',
                                                            sm: 'row',
                                                            xs: 'row'
                                                        },
                                                        justifyContent: {
                                                            xs: 'space-between',
                                                            sm: 'space-between',
                                                            md: 'unset',
                                                            lg: 'unset'
                                                        },
                                                        gap: '8px'
                                                    }}>
                                                    <Typography
                                                        alignSelf={{
                                                            lg: 'flex-end',
                                                            md: 'flex-end',
                                                            sm: 'flex-start',
                                                            xs: 'flex-start'
                                                        }}
                                                        variant='body_500'
                                                        color={palette.text.secondary}
                                                        fontSize={{
                                                            sm: '14px',
                                                            xs: '14px',
                                                            md: '16px',
                                                            lg: '16px'
                                                        }}
                                                    >
                                                        Remaining {formik?.values?.redeemValue === 'amount' ? 'Amount' : formik?.values?.redeemValue === 'units' ? 'Units' : ''}
                                                        Amount/Units
                                                    </Typography>
                                                    {isLoading ? (
                                                        <Skeleton variant='text' animation="wave" />
                                                    ) : (
                                                        <Typography
                                                            alignSelf={{
                                                                lg: 'flex-end',
                                                                md: 'flex-end',
                                                                sm: 'flex-start',
                                                                xs: 'flex-start'
                                                            }}
                                                            variant='body_600'
                                                            fontSize={{
                                                                sm: '14px',
                                                                xs: '14px',
                                                                md: '16px',
                                                                lg: '16px'
                                                            }}
                                                        >
                                                            {formik?.values?.redeemValue === 'amount' ? TotalValue?.amount?.remaining?.toFixed(2) : TotalValue?.units?.remaining}
                                                            {String.fromCharCode(parseInt(currencySymbol, 16))} {
                                                                (TotalValue()?.amount?.remaining ?? "").toFixed(2)
                                                            } / {
                                                                (TotalValue()?.units?.remaining ?? "").toFixed(2)
                                                            }
                                                        </Typography>
                                                    )
                                                    }
                                                </Box> */}
                                        {/* <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: {
                                                            lg: 'column',
                                                            md: 'column',
                                                            sm: 'row',
                                                            xs: 'row'
                                                        },
                                                        justifyContent: {
                                                            xs: 'space-between',
                                                            sm: 'space-between',
                                                            md: 'unset',
                                                            lg: 'unset'
                                                        },
                                                        gap: '8px'
                                                    }}
                                                >
                                                    <Typography
                                                        alignSelf={{
                                                            lg: 'flex-end',
                                                            md: 'flex-end',
                                                            sm: 'flex-start',
                                                            xs: 'flex-start'
                                                        }}
                                                        variant='body_500'
                                                        color={palette.text.secondary}
                                                        fontSize={{
                                                            sm: '14px',
                                                            xs: '14px',
                                                            md: '16px',
                                                            lg: '16px'
                                                        }}
                                                    >
                                                        Bank
                                                    </Typography>
                                                    {isLoading ? (
                                                        <Skeleton
                                                            variant='text'
                                                            animation="wave"
                                                        />
                                                    ) : (
                                                        <Typography
                                                            alignSelf={{
                                                                lg: 'flex-end',
                                                                md: 'flex-end',
                                                                sm: 'flex-start',
                                                                xs: 'flex-start'
                                                            }}
                                                            variant='body_600'
                                                            fontSize={{
                                                                sm: '14px',
                                                                xs: '14px',
                                                                md: '16px',
                                                                lg: '16px'
                                                            }}
                                                            textAlign="end"
                                                        >
                                                            {selectedBankDetails(formik.values.bankType)}
                                                            -
                                                        </Typography>
                                                    )}
                                                </Box> */}
                                        {/* </Box> */}
                                        {/* </Box> */}
                                        <Hidden lgUp>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    columnGap: "10px"
                                                }}
                                            >
                                                <Typography
                                                    variant="subtitle_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "14px",
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    Total Amount / Units
                                                </Typography>
                                                <Typography
                                                    variant="h2"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "25px",
                                                        color: theme.palette.text.primary
                                                    })}
                                                >
                                                    {toINR({
                                                        value: (totalAmount ?? ""),
                                                        locale,
                                                        currencyCode
                                                    }).split(" ")[1] !== '0' ? toINR({
                                                        value: (totalAmount ?? ""),
                                                        locale,
                                                        currencyCode
                                                    }) : '-'
                                                    } / {
                                                        totalUnits ? (Number(totalUnits ?? 0).toFixed(4) ?? "-") : '-'
                                                    }
                                                </Typography>
                                            </Box>
                                        </Hidden>
                                        <Hidden lgDown >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    rowGap: "10px"
                                                }}
                                            >
                                                <Typography
                                                    variant="h3"
                                                    sx={(theme: Theme) => ({
                                                        fontSize: "32px",
                                                        lineHeight: "40px",
                                                        color: theme.palette.text.primary
                                                    })}
                                                >
                                                    {toINR({
                                                        value: (totalAmount ?? ""),
                                                        locale,
                                                        currencyCode
                                                    }).split(" ")[1] !== '0' ? toINR({
                                                        value: (totalAmount ?? ""),
                                                        locale,
                                                        currencyCode
                                                    }) : '-'
                                                    } / {
                                                        totalUnits ? (Number(totalUnits ?? 0).toFixed(4) ?? "-") : '-'
                                                    }
                                                </Typography>
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "16px",
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    Total Amount / Units
                                                </Typography>
                                            </Box>
                                        </Hidden>
                                        {role === USER_ROLES.RM && (!isLoading) && mfTxnStatus && (
                                            <Typography variant="overline_600" sx={(theme: Theme) => ({ mt: 2, color: theme.palette.error[500] })} >
                                                You are not allowed to place any transactions as your transaction status is still not active.
                                            </Typography>
                                        )}


                                        <Box
                                            sx={{
                                                display: 'flex',
                                                gap: '15px',
                                                flexDirection: 'row'
                                            }}
                                        >
                                            {/* {role === USER_ROLES.RM && ( */}
                                            {![USER_ROLES.INVESTOR].includes(role) && (
                                                <>
                                                    {(isModuleAllowed({ value: "OrderRecommend", compareArr: permissions, objKey: "permissonCode" })) && (
                                                        <CustomeButton
                                                            lookType={'outlined'}
                                                            btnText={'Suggested'}
                                                            isLoading={["recomment"].includes(apiLoading)}
                                                            disabled={
                                                                // !dirty ||
                                                                isLoading ||
                                                                ["order", "investor"].includes(apiLoading) ||
                                                                (formikRef?.current?.values?.fund ?? []).length === 0 ||
                                                                (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                                    ![USER_ROLES.INVESTOR].includes(role) &&
                                                                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                                                ) || mfTxnStatus ||
                                                                TransactionStatusChkLoading
                                                            }
                                                            onClick={() => {
                                                                setOrderType('recomment')
                                                                handleSubmit()
                                                            }} />
                                                    )}
                                                    {(isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" })) && (
                                                        <CustomeButton
                                                            lookType={'contained'}
                                                            btnText={'Place Order'}
                                                            disabled={
                                                                // !dirty ||
                                                                isLoading ||
                                                                ["recomment", "investor"].includes(apiLoading) ||
                                                                EUINPopupLoading ||
                                                                (formikRef?.current?.values?.fund ?? []).length === 0 ||
                                                                (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                                    ![USER_ROLES.INVESTOR].includes(role) &&
                                                                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                                    MPOWER_ACCOUNT_TYPE_MASTER["ADV"]
                                                                ) || mfTxnStatus || !disclaimerChecked
                                                            }
                                                            isLoading={["order"].includes(apiLoading) || TransactionStatusChkLoading}
                                                            onClick={() => {
                                                                setOrderType('order')
                                                                handleSubmit()
                                                            }} />
                                                    )}
                                                </>
                                            )}
                                            {(
                                                [USER_ROLES.INVESTOR].includes(role) &&
                                                isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" })
                                            ) && (
                                                    <CustomeButton
                                                        lookType={'contained'}
                                                        btnText={'Add to Cart'}
                                                        isLoading={["investor"].includes(apiLoading)}
                                                        // disabled={!dirty || isLoading || apiLoading}
                                                        disabled={
                                                            // !dirty ||
                                                            (formikRef?.current?.values?.fund ?? []).length === 0 ||
                                                            isLoading ||
                                                            ["order", "recomment"].includes(apiLoading) || mfTxnStatus
                                                        }
                                                        onClick={() => {
                                                            setOrderType('investor')
                                                            handleSubmit()
                                                        }}
                                                    />
                                                )}
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                            <ConfirmRecomment
                                isLoading={!!apiLoading}
                                open={confirmRecomment}
                                setClose={setConfirmRecomment}
                                title={orderType === 'recomment' ?
                                    "Confirm Suggestion!" :
                                    orderType === 'order' ?
                                        "Confirm!" :
                                        ''
                                }
                                desc={orderType === 'recomment' ?
                                    "Are you sure you want to continue with this action ? You can see your old suggestions under recent suggestion tab." :
                                    "Are you sure you want to continue with this action ?"
                                }
                                handleConfirm={() => orderType === 'recomment' ?
                                    handleConfirmRecommend(values) :
                                    orderType === 'order' && handleConformOrder(values)
                                }
                            />
                            <RiskProfilePopup open={riskProfilePopup} setClose={handleRiskProfilePopup} handleConfirmOrder={() => handleConformOrder(values)} isLoading={apiLoading} text={riskPopupText} />
                            {/* Document Upload Dialog Start */}
                            <TransactionsDocumentUpload
                                open={isDocumentUploadDialogVisible}
                                onClose={handleDocumentUploadDialogClose}
                            />
                            {/* Document Upload Dialog End */}
                        </>
                    )
                }}
            </Formik>
            {cartPopup &&
                <AddtoCardPopup open={cartPopup} setClose={setCartPopup} handleSuccess={handleSuccess} />}
            <SuccessModal
                open={successModal}
                setClose={setSuccessModal}
                onclick={handleSuccessPopup}
                title="Success!"
                confirmBtnText={"Go to Dashboard"}
                // desc={orderType === 'recomment' ? "The recommended schemes will be sent to the investor." : "The transaction link will be sent via email by BSE Star for authorisation and completion of the transaction."}
                desc={successMessage ?? ""}
                subDesc={subSuccessMessage ?? ""}
            />
            <FiveSchemeErrorMessage handleCloseFiveSchemesDialog={handleCloseFiveSchemesDialog} isFiveSchemesDialogVisible={isFiveSchemesDialogVisible} />
            <ValidateDialogBox handleValidationDialogClose={handleValidationDialogClose} validationErrorsArray={validationErrorsArray} isValidationDialogVisible={isValidationDialogVisible} />
            {/* Document Upload Error Dialog Start */}
            <Dialog
                aria-labelledby="error-dialog"
                open={isDocumentUploadErrorDialogVisible}
                PaperProps={{
                    sx: {
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: palette.common.white
                    },
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <FailureIcon width="35" height="35" />
                    <Typography
                        variant="h2"
                        sx={{
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: palette.text.primary
                        }}
                    >
                        Error!
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={{
                            lineHeight: "22px",
                            letterSpacing: "0.02px",
                            color: palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        }}
                    >
                        Please upload minimum 1 document
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleDocumentUploadErrorDialogClose}
                        sx={{
                            ...typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: palette.primary[500]
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Document Upload Error Dialog End */}

            <TransactionsDisclaimerText
                handleDialogClose={() => {
                    setIsTxnDialog(false);
                    setDisclaimerChecked(true);
                }}
                isDialog={isTxnDialog}
            />


            {/* Add More Funds start */}
            {isAddMoreHoldingDialogOpen && (
                <HoldingFundMore
                    {...{
                        open: isAddMoreHoldingDialogOpen,
                        setOpen: setAddMoreHoldingDialogOpen,
                        clientCode,
                        holdingsData,
                        setHoldingsData,
                        handleProceed,
                    }}
                />
            )}
            {/* Add More Funds end */}

            <TransactionStatusPopup open={transactionStatusPopup} setClose={handleTransactionStatusPopup} res={transactionStatusPopupRes} />
            <EUINPopup open={EUINPopupVisible} setClose={() => setEUINPopupVisible(false)} handleEuinCheckClose={handleEuinCheckClose} euinRes={EUINPopupRes} />
            <TransactionStatusCheckPopup open={transactionStatusCheckPopup} setClose={handleTransactionStatusCheckPopup} res={transactionStatusCheckPopupRes} />

            {/* Multiple Orders from the same scheme/folio combination Dialog start */}
            <ConfirmRecomment
                open={isSameSchemesDialogOpen}
                setClose={handleSameSchemeDialogClose}
                title="Confirm!"
                desc="Multiple Orders with the same scheme/folio combination. Please confirm before proceeding."
                handleConfirm={handleSameSchemeDialogConfirm}
            />
            {/* Multiple Orders from the same scheme/folio combination Dialog end */}
        </>
    )
}

export default Redeem